export default __webpack_public_path__ + "static/quote-4-516b9b69fef984b6f3f00e786a3490a6.mp3";